package pages.deliveries

import ics.materialUI.components.classes.ContentFieldMapping

object DeliveriesListPageFieldMappings {
    val headerSequence: Array<String> = arrayOf(
        "recordId",
        "owner",
        "orderNumber",
        "references",
        "statusDescription",
        "totalReceived",
        "totalExpected",
        "expectedDate",
        "processingDate"
    )

    object FieldMappings {
        val english: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "recordId",
                "Record Id"
            ),
            ContentFieldMapping(
                "owner",
                "Owner"
            ),
            ContentFieldMapping(
                "orderNumber",
                "Order number"
            ),
            ContentFieldMapping(
                "references",
                "References"
            ),
            ContentFieldMapping(
                "statusDescription",
                "Status"
            ),
            ContentFieldMapping(
                "totalReceived",
                "Total received"
            ),
            ContentFieldMapping(
                "totalExpected",
                "Total expected"
            ),
            ContentFieldMapping(
                "expectedDate",
                "Expected date"
            ),
            ContentFieldMapping(
                "processingDate",
                "Processing date"
            )
        )
    }
}